import React, { useEffect } from "react";
import Header from "./header";
import Footer from "./footer";

const Cookiepolicy = () => {
  useEffect(() => {
    // Load Termly cookie policy script (equivalent to provided embed snippet)
    if (!document.getElementById("termly-jssdk")) {
      const script = document.createElement("script");
      script.id = "termly-jssdk";
      script.type = "text/javascript";
      script.src = "https://app.termly.io/embed-policy.min.js";
      script.async = true;

      const firstScriptTag = document.getElementsByTagName("script")[0];
      if (firstScriptTag && firstScriptTag.parentNode) {
        firstScriptTag.parentNode.insertBefore(script, firstScriptTag);
      } else {
        document.body.appendChild(script);
      }
    }
  }, []);

  return (
    <div>
      <Header />
      <div className="container my-4">
        {/* Cookie Policy embed */}
        <div
          name="termly-embed"
          data-id="e330c655-e616-4b75-82d2-9b741408d7a9"
        ></div>

        {/* Cookie Consent Preferences link (preference center) */}
        <div className="mt-3">
          <a href="#" className="termly-display-preferences">
            Consent Preferences
          </a>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default Cookiepolicy;
